export default class RemoveJobPlacementsFromInvoiceRequest {
  jobPlacementIds: string[] = [];
}
